import React from 'react';
import PropTypes from 'prop-types';

import { phoneFrameStyles } from '../phoneFrameStyles';
import Preview from '../Preview';

import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PreviewModal = ({open, onClose, originalOrganizationSlug, organization, socials, links}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="xs"
      hideBackdrop={false}
      keepMounted={true}
      disablePortal={false}
      disableEnforceFocus={false}
      sx={{ zIndex: 1300 }}
      PaperProps={{
        sx: {
          position: "relative",
          ...phoneFrameStyles
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "grey",
          zIndex: 10,
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <Preview originalOrganizationSlug={originalOrganizationSlug} organization={organization} socials={socials} links={links} />
    </Dialog>
  );
};

PreviewModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  originalOrganizationSlug: PropTypes.string,
  organization: PropTypes.object,
  socials: PropTypes.array,
  links: PropTypes.array,
};

export default PreviewModal;